// @owner ClientPlatform

import type {FC, FormEventHandler, PropsWithChildren, ReactNode} from 'react';
import React from 'react';
import {styled} from 'styled-components';
import {StyledForm} from '../../commonSigninStyles';
import {FrontLogo} from '../../../common/components/frontLogo';
import {PrivacyFooter} from '../../../common/components/privacyFooter';

const StyledLogo = styled(FrontLogo)`
  margin: 0 auto 8px;
`;

// Grows to fill the space above the privacy footer and centers the card within it, so
// the card stays centered while the footer stays at the bottom — without overlapping.
const StyledCardRegion = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

interface AuthCardProps {
  name?: string;
  onSubmit?: FormEventHandler<HTMLFormElement>;
  logo?: ReactNode;
}

export const AuthCard: FC<PropsWithChildren<AuthCardProps>> = ({name, onSubmit, logo, children}) => (
  <>
    <StyledCardRegion>
      <StyledForm name={name} onSubmit={onSubmit}>
        {logo ?? <StyledLogo />}
        {children}
      </StyledForm>
    </StyledCardRegion>
    <PrivacyFooter />
  </>
);
